import IRootState from '@/app/common/model/IRootState';

const state: IRootState = {
  translations: {},
  license: null,
  reCaptcha: null,
  loading: false,
  licenseImages: {
    variableType: null,
    type: null,
    id: null,
    value: null,
  },
  menuLogo: {
    variableType: null,
    type: null,
    id: null,
    value: null,
  },
  userSettings: {
    variableType: null,
    type: null,
    id: null,
    value: null,
  },
  currentLang: process.env.VUE_APP_I18N_LOCALE,
  languageList: [],
};
export default state;
